// Interface para resposta da API ViaCEP
interface ViaCEPResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

// Interface para endereço formatado
export interface EnderecoViaCEP {
  cep: string;
  logradouro: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
}

/**
 * Busca endereço pelo CEP usando a API ViaCEP
 * @param cep - CEP no formato 00000-000 ou 00000000
 * @returns Promise com os dados do endereço ou null se não encontrado
 */
export const buscarEnderecoPorCEP = async (cep: string): Promise<EnderecoViaCEP | null> => {
  try {
    // Remove caracteres não numéricos do CEP
    const cleanCEP = cep.replace(/\D/g, '');
    
    // Verifica se o CEP tem 8 dígitos
    if (cleanCEP.length !== 8) {
      return null;
    }

    // Faz a requisição para a API ViaCEP
    const response = await fetch(`https://viacep.com.br/ws/${cleanCEP}/json/`);
    
    if (!response.ok) {
      throw new Error('Erro na requisição para ViaCEP');
    }

    const data: ViaCEPResponse = await response.json();

    // Verifica se o CEP foi encontrado
    if (data.erro) {
      return null;
    }

    // Retorna os dados formatados
    return {
      cep: data.cep,
      logradouro: data.logradouro,
      complemento: data.complemento || '',
      bairro: data.bairro,
      cidade: data.localidade,
      uf: data.uf
    };
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    return null;
  }
};
